import * as React from 'react';
import { Box } from '@leagueplatform/genesis-core';
import {
  MasonryEngineNode,
  MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';
import { MasonryChart } from '#types/masonry-chart.type.ts';
import { usePaginationAction } from '../infinite-pagination-renderer/use-pagination-action';
import {
  InfinitePagination,
  InfinitePaginationProps,
} from '../infinite-pagination-renderer/infinite-pagination.component';
import { Chart } from '../chart-renderer/chart.component';

type PaginatedChartNode = MasonryEngineNode<
  'paginatedChart',
  {
    pagination: InfinitePaginationProps;
    chart: MasonryChart & {
      items: React.ReactElement[];
    };
  }
>;
export type PaginatedChartRendererProps =
  MasonryEngineNodeRendererProps<PaginatedChartNode>;

export function PaginatedChartRenderer({
  pagination,
  chart,
  nodeId,
  isReloading,
}: PaginatedChartRendererProps) {
  const onPreviousPage = usePaginationAction({
    from: pagination.previousPageCursor,
    nodeIds: [nodeId],
  });
  const onNextPage = usePaginationAction({
    from: pagination.nextPageCursor,
    nodeIds: [nodeId],
  });

  return (
    <>
      <InfinitePagination
        currentPageLabel={pagination.currentPageLabel}
        previousPageLabel={pagination.previousPageLabel}
        previousPageCursor={pagination.previousPageCursor}
        onPreviousPage={onPreviousPage}
        nextPageLabel={pagination.nextPageLabel}
        nextPageCursor={pagination.nextPageCursor}
        onNextPage={onNextPage}
        isLoading={isReloading}
      />
      {chart.items}
      <Box css={{ height: 500, width: '100%', marginBottom: '$twoAndHalf' }}>
        <Chart
          chartType={chart.chartType}
          interval={chart.interval}
          aggregationBucketType={chart.aggregationBucketType}
          screenReaderTitle={chart.screenReaderTitle}
          screenReaderDescription={chart.screenReaderDescription}
          yAxisLabel={chart.yAxisLabel}
          yAxisMax={chart.yAxisMax}
          xAxisLabel={chart.xAxisLabel}
          dataset={chart.dataset}
          dataPointTypes={chart.dataPointTypes}
        />
      </Box>
    </>
  );
}
